module.exports = __webpack_public_path__ + "img/bg.30e4708f.jpg";